import SafeImage from '@ui/SafeImage';

import HeaderImageWeb from '@i/sell-your-gear/bannerWeb.png';
import HeaderImageMobile from '@i/sell-your-gear/bannerMobile.png';
import Button from '@ui/Button';

interface SellYourGearHeaderProps {}

const SellYourGearHeader = ({}: SellYourGearHeaderProps) => {
  return (
    <div className="relative w-full ">
      <div className="hidden md:block">
        <SafeImage src={HeaderImageWeb} alt="header image" className="w-full" />
      </div>
      <div className="md:hidden">
        <SafeImage
          src={HeaderImageMobile}
          alt="header image"
          className="w-full"
        />
      </div>
      <div className="absolute inset-0 top-[1rem] z-10 mt-[4rem]  flex  flex-col items-center text-center text-black sm:items-start md:left-[15rem] md:mx-0  md:mt-0 md:text-left lg:top-[15rem]">
        <h1 className="hidden text-[2.4rem] font-semibold sm:inline md:text-[4rem]">
          Selling on MX Locker
        </h1>
        <div className="hidden text-[1.8rem] font-normal sm:inline">
          Ready to get started? Here&apos;s what you need to know.
        </div>
        <div className="mt-[2.2rem] inline  content-center ">
          <Button
            type="secondary"
            text="Start selling"
            width="fixed"
            href="/become-a-seller"
          />
        </div>
      </div>
    </div>
  );
};

export default SellYourGearHeader;
